import type { GateToggles } from 'app/types/workflow-gates'
import { useFeatureToggle, useFeatureToggleState } from 'app/hooks/useFeatureToggle'

const RELEASED: GateToggles = { schedulingAgent: true, paperwork: true }

/** The feature toggles the workflow gates read. Until the toggles answer, every one counts as
 *  released: `useFeatureToggle` says false while loading, which would hide a saved step and block
 *  going live for a moment on every cold load. Components reading this must be `observer`s. */
export function useGateToggles(): GateToggles {
  const schedulingAgent = useFeatureToggle(`scheduling-agent`)
  const paperwork = useFeatureToggle(`paperwork`)
  const { settled } = useFeatureToggleState(`paperwork`)
  return settled ? { schedulingAgent, paperwork } : RELEASED
}
